import { ButtonLink, typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

export const FooterRoot = styled.div<{ $hasScroll?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 20px;
  background-color: var(--surface-default);
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: ${({ $hasScroll }) => ($hasScroll ? '0' : '8px')};
`;

export const FooterText = styled.p`
  ${typographyV2.bodyXs};
  color: var(--text-default);
`;

export const StyledButtonLink = styled(ButtonLink)`
  ${ButtonLink.Styled.Label} {
    ${typographyV2.uiXs};
  }
`;
